export const getAgworldURL = () => 'https://www.agworld.com/' as const
